export const BASE_URL =
  // "http://192.168.0.16/ziro-script-laravel/public/crmapi/"; // local
  // "http://192.168.0.28/ziro-script-laravel/public/crmapi/"; // sujith local
  // "http://192.168.1.30/newvow-script-laravel/public/crmapi/"; // local
  "https://uat.script.zirostays.com/crmapi/"; //UAT URL,
// "https://backend.zirostays.com/crmapi/"; //master,
// "https://192.168.0.25/ziro-script-laravel/public/crmapi/";

export const URL = {
  LOGIN: "admin/login",
  LOGOUT: "admin-logout",

  // admin
  ADMIN: "admins-list",
  ADMINSTATUS: "admin/status/",
  ADMINVIEW: "admin/",
  ADMINDELETE: "admin/",
  ADMINEDIT: "admin/",
  ADMINROLE: "role",
  ADMINADD: "admin",

  // Minimum Age
  AGESLIST: "room-categories-list",
  AGESEDIT: "room-categories/",
  AGESADD: "room-categories",
  AGESSTATUS: "room-categories/",
  AGESVIEW: "room-categories/",

  // Property Content
  PROPERTYCONTENT: "property-content",

  // PROPERTYCONTENTVIEW: "property-content/",
  PROPERTYCONTENTVIEW: "property-content/",
  PROPERTYCONTENTUPDATE: "property-content/update",

  //Get Locations
  TOTAL_LOACATIONS: "get-locations",

  TOTAL_CITY_LIST: "locations",

  // Banners
  BANNERLIST: "banners-list",
  BANNERADD: "banners",
  BANNERDELETE: "banners/",
  BANNERVIEW: "banners/",
  BANNEREDIT: "banners/",
  BANNERLOCATION: "get-locations",

  // Room Category
  ROOMLIST: "room-categories-list",
  ROOMVIEW: "room-categories/",
  ROOMSTATUS: "room-categories/",
  ROOMEDIT: "room-categories/",
  ROOMADD: "room-categories",
  ROOMDROP: "room-categories-list",

  // Amenities
  AMENITIESLIST: "amenities-list",
  AMENITIESSTATUS: "amenities/",
  AMENITIESEDIT: "amenities/",
  AMENITIESVIEW: "amenities/",
  AMENITIESADD: "amenities",
  AMENITIESDROP: "amenities-list",
  PROPERTY_AMENITIES_LIST: "amenities",

  // Users List
  USERLIST: "users-list",
  USERLISTVIEW: "users/",
  USERLISTEDIT: "user/",
  USERSTATUS: "user/",
  // OWNERS LIST
  OWNERSLIST: "owners-list",
  OWNERSGET: "owners",
  OWNERSLISTVIEW: "owners/",
  OWNERSLISTEDIT: "owners-update/",
  OWNERSLISTADD: "owners-new",
  OWNERSDROPLIST: "owners",
  OWNERSTATUS: "owner/",

  // Default Banners
  DEFAULT_BANNER_LIST: "settings-view",
  DEFAULT_BANNER_EDIT: "settings-update",
  DEFAULT_BANNER_VIEW: "settings-view",

  // Reception list
  RECEPTIONGET: "receptions",
  RECEPTIONLIST: "receptions-list",
  RECEPTIONVIEW: "receptions/",
  RECEPTIONADD: "receptions",
  RECEPTIONEDIT: "receptions/",
  RECEPTIONSTATUS: "receptions/status",

  // Property Add
  PROPERTY_ADD: "properties-add",
  PROPERTY_VIEW: "properties-view",
  PROPERTY_EDIT: "properties-edit",

  //Property Details
  PROPERTY_CONTENT_LIST: "property-content",
  PROPERTY_DETAILS_ADD: "property-details",
  PROPERTY_ROOM_DETAILS_ADD: "property-rooms",

  // Locations
  LOCATIONLIST: "filter-locations",
  LOCATIONLISTS: "locations",
  AREAADD: "locations",
  COUNTRYLIST: "countries",
  CITYVIEW: "cities/",
  LOCATIONSEDIT: "/locations/",
  AREAVIEW: "areas/",
  AREAEDIT: "areas/",

  // STATELIST:"states/",
  COUNTRYADD: "countries/store",
  STATEADD: "states/store",
  CITYADD: "cities/store",
  AREAADD: "areas/store",
  STATESLIST: "states/",
  CITYLIST: "cities/",
  AREALIST: "areas/",
  DROPDOWN_LOCATIONS: "get-locations",

  //Properties List
  PROPERTIES_LIST: "properties",
  PROPERTIES_STATUS: "properties/status-change",
  PROPERTIES_BLOCKED_DATE: "block/blocked/dates",
  PROPERTIES_BLOCK: "block/property",
  PROPERTIES_ROOM_AVAILABLE: "block/room/available",
  PROPERTIES_ROOM_BLOCK: "block/room",

  //Properties room View
  PROPERTIES_ROOM_VIEW: "room",

  // ROLES
  ROLESLIST: "role-list",
  ROLESADD: "role",
  ROLESVIEW: "role/",
  ROLESDELETE: "role/",
  ROLESEDIT: "role/",
  ROLESPERMISSION: "permissions-list",

  //Property Document Add
  PROPERTY_DOCUMENT_ADD: "/property/upload-documents",

  //Property MMC Payment
  PROPERTY_MMC_PAYMENT: "/razorpay/subscription/create",
  PROPERTY_MMC_RESPONSE: "/razorpay/subscription/client/response",

  // Property Verification
  PROPERTY_REQUEST: "properties/filter/list",
  // Property document Verification
  PROPERTY_DOCUMENT_REQUEST: "property/document/",
  PROPERTY_REQUEST_APPROVE: "properties",
  //Property Image Delete
  PROPERTY_IMAGE_DELETE: "property/image",
  //Property Document Update
  PROPERTY_DOCUMENT_UPDATE: "property/upload-documents",
  //Property reception list
  PROPERTY_RECEPTION_LIST: "property/owner/",

  // Subscription
  SUBSCRIPTION: "subscription",
  SUBSCRIPTION_SUSPEND: "subscription/suspend/list",
  SUBSCRIPTION_REQUEST: "subscription/request/list",
  SUBSCRIPTION_APPROVED: "subscription/approved/list",
  SUBSCRIPTION_REJECT: "subscription/reject/list",
  SUBSCRIPTION_APPROVAL: "razorpay/subscription/",
  SUBSCRIPTION_REJECTION: "razorpay/subscription/",
  PROPERTIES_LIST_DROP: "property",

  // Blocked
  PROPERTY_BLOCK_LIST: "unblock",
  PROPERTIES_DROP_LIST: "unblock/filter/property-names",

  //Unblock
  PROPERTY_BLOCKED_DATES: "unblock/blocked/list",
  UNBLOCK_PROPERTY: "unblock/property",
  UNBLOCK_ROOM: "unblock/room",

  // Bookings
  BOOKINGS_UPCOMING: "properties-bookings",
  BOOKINGS_COMPLETED: "checkedout-bookings",
  BOOKINGS_CANCELLED: "cancel-bookings",

  // Review
  REVIEWS_LIST: "reviews-list",
  REVIEWS_LIST_VIEW: "review/",
  REVIEWS_LIST_CHECK: "/property-reviews/homepage",
  REVIEWS_STATUS: "review/change/status",
  REVIEWS_DELETE: "review/delete/",

  // Dashboard details
  DASHBOARD_DETAILS: "dashboard-stats",
  DASHBOARD_DATE_DETAILS: "dashboard-full-stats",

  // Suspended property
  // SUSPENDED_PROPERTY_LIST: "/property/suspend/all/list",
  SUSPENDED_PROPERTY_LIST: "/property/suspend/list",
  UNSUSPENDED_PROPERTY_LIST: "/property/unsuspend",
  SUSPENDED_VIEW_TABLE_LIST: "property/suspend/show",
  SUSPENDED_DESCRIPTION_ADD: "property/suspend/comment",
  ADMIN_SUSPENDED_LIST: "/property/admin/suspend/list",

  // User Bookings
  USER_BOOKING_DETAILS: "/bookings/date-range",

  // PROPERTY REVERIFICATION
  PROPERTY_REVERIFICATION_LIST: "reverification-list",
  REVERIFICATION_PROPERTY_VIEW: "reverification-show/",
  REVERIFICATION_PROPERTY_DETAILS: "/properties/reverificatoin-list",
  REVERIFICATION_PROPERTY_ROOMS: "/properties/reverificatoin-list",
  REVERIFICATION_PROPERTY_DOCUMENTS: "/properties/reverificatoin-list",
  REVERIFICATION_APPROVE_REJECT: "reverification/approve-updates",

  //PROPERTRY FOLLOW-UP

  PROPERTY_FOLLOWUP: "/property/suspend/comment/list/all",

  // Notification List
  PROPERTY_NOTIFICATION: "notification/property",
  SUSPENDED_NOTIFICATION: "/notification/suspend",
  MMC_NOTIFICATION: "/notification/mmc",
  OTHERS_NOTIFICATION: "/notification/others",
  NOTIFICATION_REPLY: "/notification/reply",

  // Sales List
  SALES_LIST: "approved-properties/admin-count",
  SALES_VIEW: "approved-properties/",

  //Chat Count
  CHAT_OVERALL_COUNT: "/chat/report",
  CHAT_DETAIL_COUNT: "/chat/report/",
};

export const TOKEN = "token";
export const LOGGEDUSER = "loggeduser";
export const USER_DETAILS = "user_details";
export const PROFILE = "profile";
export const LOCATION = "userlocation";
export const LOCATIONNAME = "locationname";
export const GOOGLE_MAP_KEY = "AIzaSyAJJyn2YN6kCvs3XxEMC9XIhB1xPGjkBW4";
export const OLA_MAP_KEY = "lcndCmgsSIcmietX3bkCGIFMG1ijjKwLkDA0ZeCK";

export const NUMBER = /^\+?(0|[6-9]\d*)$/;
export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const productDetailImg = {
  loop: true,
  autoplay: false,
  center: true,
  dots: true,
  autoplayTimeout: 3000,
  smartSpeed: 450,
  nav: false,
  responsive: {
    0: {
      items: 1,
    },
  },
};

export const configJodit = {
  activeButtonsInReadOnly: ["source", "fullsize", "print", "about", "dots"],
  buttons: [
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "|",
    "ul", // Unordered list
    "ol", // Ordered list
    "|",
    "fontsize",
    "font",
    "brush", // Text color & background color
    "paragraph", // Format block (Headings)
    "lineHeight", // Line height adjustment
    "align",
    "dots",
  ],
  toolbarSticky: false, // Keeps toolbar flexible
  toolbarAdaptive: true, // Ensures responsiveness
  toolbarButtonSize: "small", // Makes buttons smaller on small screens
  // height: "auto", // Auto height for responsiveness
  // minHeight: 200, // Prevents the editor from collapsing
  spellcheck: true,
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  showPlaceholder: false,
};

// export const RAZORPAY_KEY = "rzp_live_RvuUYHzzAJoPtT"; //Live key
export const RAZORPAY_KEY = "rzp_test_VgUSXPGATug5YQ"; //Tesk key
